
import { Component     } from '@angular/core';
import { ViewChild     } from '@angular/core';
import { ElementRef    } from '@angular/core';
import { HostListener  } from '@angular/core';

import { ConsoleService    } from '@service/console.service';
import { PlatformService   } from '@service/platform.service';
import { FilesystemService } from '@service/filesystem.service';

@Component({
    selector: 'section-companies',
    styleUrls: [ 'section-companies.template.scss' ],
    templateUrl: 'section-companies.template.html'
})
export class SectionCompaniesComponent {

    public content: any = {};
    public animate: boolean = false;

    @ViewChild('checkpoint')
    public checkpoint!: ElementRef;

    constructor (private console: ConsoleService,
                 private platform: PlatformService,
                 private filesystem: FilesystemService) {

    }

    ngOnInit () {
        this.console.info('Starting SectionCompanies');

        let main: any = this.filesystem.readSession('main');
        if (main) {
            this.content = main;
        }
    }

    ngOnDestroy () {
        this.console.info('Destroying SectionCompanies');
    }

    get language () {
        return this.filesystem.readSession('language');
    }

    @HostListener('window:scroll', [ '$event' ])
    @HostListener('window:resize', [ '$event' ])
    public animateBySrcoll ($event: any) {
        this.animate = this.platform.isInView(
            this.checkpoint.nativeElement, window.innerHeight / 3
        );
    }

}
